export const MANNEQUIN_DIMENSIONS = {
  torsoBase: [0, 7.77, 0] as [number, number, number],
  torsoHeight: 5.45,
  stomachHeight: 2.18,
  chestOffset: 2.0,
  neckLen: 0.5,
  headOffset: [0, .5, 0] as [number, number, number],
  shoulderWidth: 1.57,
  upperArmLen: 3.2,
  lowerArmLen: 2.5,
  hipOffset: [0.95, 0, 0.3] as [number, number, number],
  pelvicHeight: 1.2,
  upperLegLen: 4.0,
  lowerLegLen: 3.66,
  footDim: [0.3, 0.2, 0.8] as [number, number, number],
  palmDim: [0.25, 0.35, 0.1] as [number, number, number],
  headDim: [0.7, 0.95, 0.85] as [number, number, number]
};
